<div class="cookie-disclaimer-wrapper">
  <div class="cookie-disclaimer-title">🍪 Sütiket használunk</div>
  <div class="cookie-disclaimer-content">
    Az oldal működéséhez szükséges sütiket használunk. Analitikai célokra csak a hozzájárulásoddal gyűjtünk adatot.
    <br />
    Részleteket az
    <a routerLink="/adatvedelmi-tajekoztato" class="privacy-link">adatvédelmi tájékoztatóban</a> találsz.
  </div>
  <div class="cookie-disclaimer-button-container">
    <button (click)="acceptAll()" class="new-netfone-button secondary black">Minden süti engedélyezése</button>
    <button (click)="acceptFunctionalOnly()" class="new-netfone-button grey uppercase">Csak a szükségesek</button>
  </div>
</div>
